import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

import { Berater } from '../../../shared/model/berater.model';

/** NP20-1285: Export, Two Pager und KI-Profilabgleich liegen jetzt im Profil; das Menue verweist dorthin. */
@Component({
  selector: 'app-bonus-actions',
  imports: [RouterLink, TranslatePipe],
  templateUrl: './bonus-actions.component.html',
  styleUrl: './bonus-actions.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class BonusActionsComponent {
  @Input() berater: Berater;
  @Input() openMenuId: string | null = null;

  @Output() toggleMenu = new EventEmitter<string>();
  @Output() closeMenu = new EventEmitter<void>();

  @ViewChild('trigger') private trigger?: ElementRef<HTMLButtonElement>;

  constructor(
    private elementRef: ElementRef,
    private router: Router,
  ) {}

  get isOpen(): boolean {
    return !!this.berater && this.openMenuId === this.berater.id;
  }

  get consultantName(): string {
    return [this.berater?.vorname, this.berater?.nachname]
      .filter(Boolean)
      .join(' ');
  }

  onToggleClick(userId: string) {
    this.toggleMenu.emit(userId);
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (this.isOpen && !this.elementRef.nativeElement.contains(event.target)) {
      this.closeMenu.emit();
    }
  }

  @HostListener('document:keydown.escape')
  onEscape() {
    if (!this.isOpen) return;
    this.closeMenu.emit();
    this.trigger?.nativeElement.focus();
  }

  openProfile() {
    this.closeMenu.emit();
    this.router.navigate(['/profile', this.berater.id]);
  }
}
